import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { requestWithToken, requestWithoutToken } from 'src/config';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {

  private statusId!: any;

  setStatusId(id: any) {
    this.statusId = id;
  }

  getStatusId(): any {
    return this.statusId;
  }


  async fetchValidationList(pageNo: any, pageSize: any) {
    const p = {
      start: pageNo,
      size:pageSize
    };
    return requestWithToken(
      'POST',
      `/admin/businessInfoList`,p
    )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async fetchValidationDetails(id: any) {
    return requestWithToken('GET', `/admin/businessInfo/${id}`)
      .then((res) => {
        console.log(res);
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async getValidationProductListing(
    search: string,
    page: number,
    size: number,
    filter: any
  ) {
    const p = {
      start: (page - 1) * size,
      size,
      search,
      ...filter,
    };
    function createGetRequestUrl(baseUrl: string, params: any) {
      // Create a new URLSearchParams object
      const urlParams = new URLSearchParams();

      // Loop through the parameters and add them to the URLSearchParams
      for (const key in params) {
        if (
          params.hasOwnProperty(key) &&
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ''
        ) {
          urlParams.append(key, params[key]);
        }
      }

      // Combine the base URL and the parameters
      const fullUrl =
        baseUrl + (urlParams.toString() ? `?${urlParams.toString()}` : '');

      return fullUrl;
    }

    return requestWithToken('GET', createGetRequestUrl(`/admin/business`, p));
  }

  async fetchValidationListWithBody(
    searchLike: String,
    page: number,
    size: number,
    filter: any
  ) {
    const p = {
      start: (page - 1) * size,
      size,
      ...(searchLike && searchLike.trim() !== '' ? { searchLike } : {}),
      ...filter,
    };

    return requestWithToken('POST', `/admin/businessInfoList`,p);
  }

  async fetchDocStatus() {
    return requestWithToken('GET', '/masters/docStatus')
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async fetchBusinessWorkFlow(businessId: number) {
    return requestWithToken('GET', `/admin/businessInfo/workFlow/${businessId}`)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }


  async fetchAllBusinessWorkFlow() {
    return requestWithToken('GET', `/admin/businessInfo/workFlow`)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async updateStatusOfBusiness(statusId: String, id : string) {
    return requestWithToken('PUT', `/admin/businessInfo/update/status?statusId=${statusId}&id=${id}`)
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async fetchProdCategory() {
    return requestWithoutToken('GET', '/masters/prodCategory')
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }

  async fetchSubCategory(catId: number) {
    const p = {
      catId: catId,
    };
    function createGetRequestUrl(baseUrl: string, params: any) {
      // Create a new URLSearchParams object
      const urlParams = new URLSearchParams();

      // Loop through the parameters and add them to the URLSearchParams
      for (const key in params) {
        if (
          params.hasOwnProperty(key) &&
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ''
        ) {
          urlParams.append(key, params[key]);
        }
      }

      // Combine the base URL and the parameters
      const fullUrl =
        baseUrl + (urlParams.toString() ? `?${urlParams.toString()}` : '');

      return fullUrl;
    }

    return requestWithoutToken(
      'GET',
      createGetRequestUrl(`/masters/subCategory`, p)
    )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        return error;
      });
  }


  async validationDetailSave(payload: any) {
    return requestWithToken(
      "PUT",
      "/admin/update/businessInfo",
      payload
    ).then((res) => {
      return res?.data;
    }).catch((error) => {
      return error;
    })
  }


}
